import { TemplatePage } from './types';

const live_streaming_key_takeaway: TemplatePage = {
  header: {
    color: '#FFE56C',
    icon: 'images/video-templates/key.jpg',
    title: 'Live Stream Key Takeaways Templates',
    title_meta: '20+ Free Key Takeaways Templates for Live Streams',
    description_meta:
    'Outline the key takeaways and points of your presentation using these easy-to-customize live' +
    ' streaming templates. Visualize the main ideas of your talk in a comprehensible and engaging way!',
    description:
      'Outline the key takeaways and points of your presentation using these easy-to-customize live' +
      ' streaming templates. Visualize the main ideas of your talk in a comprehensible and engaging way!'
  },
  footer: {
    category: 'Live stream key takeaways templates',
    description:
      "Become a top-notch live streamer in no time with Wave.video's collection of free editable" +
      ' templates. Pick a pack of live streaming templates that fits your branding and style, and create' +
      ' beautiful thumbnails, intros, technical screens, countdowns, lower thirds, and many other visual' +
      ' elements with ease.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live stream key takeaways templates',
      search: { name: 'LiveKey', tags: 'LiveKey' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_key_takeaway;
